import {
	GET_REFERRAL_SOURCES_REQUEST,
	GET_REFERRAL_SOURCES_SUCCESS,
	GET_REFERRAL_SOURCES_ERROR,
	GET_REFERRAL_SOURCE_REQUEST,
	GET_REFERRAL_SOURCE_SUCCESS,
	GET_REFERRAL_SOURCE_ERROR,
	CREATE_REFERRAL_SOURCE_REQUEST,
	CREATE_REFERRAL_SOURCE_SUCCESS,
	CREATE_REFERRAL_SOURCE_ERROR,
	EDIT_REFERRAL_SOURCE_REQUEST,
	EDIT_REFERRAL_SOURCE_SUCCESS,
	EDIT_REFERRAL_SOURCE_ERROR,
	DELETE_REFERRAL_SOURCE_REQUEST,
	DELETE_REFERRAL_SOURCE_SUCCESS,
	DELETE_REFERRAL_SOURCE_ERROR
} from "@/actions"

import {
	referralSourceService
} from "@/services"

import { addNewFilter, isEmpty, decodeLaravelValidationErrors } from "@/utilities"

const state = {
	referralSources: [],
	referralSource: {},
	loading: false
}

const getters = {
	referralSource: state => state.referralSource,
	referralSources: state => state.referralSources,
	referralSourceSelectOptions: state => state.referralSources.filter(i => i.deleted_at == null).sort((a, b) => a.sort - b.sort).map(rs => ({
		value: rs.uuid,
		label: rs.name,
		'data-sort': rs.sort
	})),
	referralSourceByUuid: state => uuid => state.referralSources.find(rs => rs.uuid == uuid)
}

const actions = {
	async getReferralSources({ commit }) {
		commit("GET_REFERRAL_SOURCES_REQUEST")
		const response = await referralSourceService.getReferralSources();
		const { status, data } = response
		switch (status) {
			case 200:
				commit("GET_REFERRAL_SOURCES_SUCCESS", data)
				break
			default:
				commit("GET_REFERRAL_SOURCES_ERROR")
		}
		return response
	},
	async getReferralSource({ commit }, params) {
		commit("GET_REFERRAL_SOURCE_REQUEST")
		const response = await referralSourceService.getReferralSource(params)
		const { status, data } = response
		switch (status) {
			case 200:
				commit("GET_REFERRAL_SOURCE_SUCCESS", data)
				break
			default:
				commit("GET_REFERRAL_SOURCE_ERROR");
		}
		return response
	},
	async createReferralSource({ commit, dispatch }, params) {
		commit("CREATE_REFERRAL_SOURCE_REQUEST")
		const response = await referralSourceService.createReferralSource(params)
		const { status, data } = response
		switch (status) {
			case 200:
				if (data.success) {
					commit("CREATE_REFERRAL_SOURCE_SUCCESS", data);
					dispatch("alert/createAlertSuccess", "Referral source created.", { root: true });
				}

				if (data?.error) {
					commit("CREATE_REFERRAL_SOURCE_ERROR");
					dispatch("alert/createAlertErrors", data.errors ? decodeLaravelValidationErrors(data.errors) : "Opps. Something went wrong. Referral source not created.", { root: true });
				}

				break
			default:
				commit("CREATE_REFERRAL_SOURCE_ERROR")
		}
		return response
	},
	async editReferralSource({ commit, dispatch }, params) {
		commit("EDIT_REFERRAL_SOURCE_REQUEST")
		const response = await referralSourceService.editReferralSource(params)
		const { status, data } = response
		switch (status) {
			case 200:
				if (data.success) {
					commit("EDIT_REFERRAL_SOURCE_SUCCESS", data);
					dispatch("alert/createAlertSuccess", "Referral source updated.", { root: true });
				}

				if (data?.error) {
					commit("EDIT_REFERRAL_SOURCE_ERROR");
					dispatch("alert/createAlertErrors", data.errors ? decodeLaravelValidationErrors(data.errors) : "Opps. Something went wrong. Referral source not updated.", { root: true });
				}

				break
			default:
				commit("EDIT_REFERRAL_SOURCE_ERROR")
		}
		return response
	},
	async deleteReferralSource({ commit, dispatch }, uuid) {
		commit("DELETE_REFERRAL_SOURCE_REQUEST")
		const response = await referralSourceService.deleteReferralSource(uuid)
		const { status, data } = response
		switch (status) {
			case 200:
				if (data.success) {
					const { referral_source } = data;
					commit("DELETE_REFERRAL_SOURCE_SUCCESS", { ...referral_source, uuid });
					dispatch("alert/createAlertSuccess", "Referral source deleted.", { root: true });
				}

				if (data.error) {
					dispatch("alert/createAlertErrors", data.errors ? decodeLaravelValidationErrors(data.errors) : "Opps. Something went wrong. Referral source not deleted.", { root: true });
				}

				break
			default:
				console.log("delete referral source error", response)
				commit("DELETE_REFERRAL_SOURCE_ERROR")
		}
		return response
	},
	async reorderReferralSources({ commit, dispatch }, params) {
		return await referralSourceService.reorderReferralSources(params)
	},
	async updateSortOrder({ commit, dispatch }, params) {
		commit("UPDATE_SORT_ORDER", params)
	}
}

const mutations = {
	[GET_REFERRAL_SOURCES_REQUEST]: state => {
		state.loading = true
	},
	[GET_REFERRAL_SOURCES_SUCCESS]: (state, data) => {
		const referralSources = data.referral_sources
		state.referralSources = referralSources
		state.loading = false
	},
	[GET_REFERRAL_SOURCES_ERROR]: state => {
		state.loading = false
		state.error = true
	},
	[GET_REFERRAL_SOURCE_REQUEST]: state => {
		state.loading = true
	},
	[GET_REFERRAL_SOURCE_SUCCESS]: (state, data) => {
		const { referral_source } = data
		state.referralSources = addNewFilter(state.referralSources, [referral_source])
		state.loading = false
	},
	[GET_REFERRAL_SOURCE_ERROR]: (state, data) => {
		state.loading = false
	},

	[CREATE_REFERRAL_SOURCE_REQUEST]: state => {
		state.loading = true
	},
	[CREATE_REFERRAL_SOURCE_SUCCESS]: (state, data) => {
		const { referral_source } = data
		state.referralSources = addNewFilter(state.referralSources, [referral_source])
		state.loading = false
	},
	[CREATE_REFERRAL_SOURCE_ERROR]: state => {
		state.loading = false
	},

	[EDIT_REFERRAL_SOURCE_REQUEST]: state => {
		state.loading = true
	},
	[EDIT_REFERRAL_SOURCE_SUCCESS]: (state, data) => {
		const { referral_source } = data
		state.referralSources = addNewFilter(state.referralSources, [referral_source])
		state.loading = false
	},
	[EDIT_REFERRAL_SOURCE_ERROR]: state => {
		state.loading = false
	},

	[DELETE_REFERRAL_SOURCE_REQUEST]: state => {
		state.loading = true
	},
	[DELETE_REFERRAL_SOURCE_SUCCESS]: (state, referral_source) => {
		const { deleted_at, uuid } = referral_source
		if (!isEmpty(deleted_at)) {
			state.referralSources = addNewFilter(state.referralSources, [referral_source])
		} else {
			state.referralSources = state.referralSources.filter(rs => rs.uuid != uuid)
		}

		state.loading = false
	},
	[DELETE_REFERRAL_SOURCE_ERROR]: (state) => {
		state.loading = false
	},
	UPDATE_SORT_ORDER: (state, params) => {
		state.referralSources = state.referralSources.map(item => item?.uuid === params?.uuid ? { ...item, sort: params?.sort } : item);
	}
}

export const referralSource = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}